<template>
    <img :src="imageUrl" :class="imageClasses" :style="imageStyles">
</template>

<script>
    export default {
        name: 'ImageRenderer',
        props: ['component'],
        computed: {
            imageUrl() {
                return this.component.value.url
            },
            imageClasses() {
                return `w-100 ${this.marginClasses} ${this.paddingClasses} ${this.borderClass}`.trim()
            },
            marginClasses() {
                if(!this.component.margin) {
                    return ''
                }

                return webase.utils.ui.getMarginClass(this.component.margin)
            },
            paddingClasses() {
                if (!this.component.padding) {
                    return ''
                }

                return webase.utils.ui.getPaddingClass(this.component.padding)
            },
            borderClass() {
                if(!this.component.border || this.component.border === 'none') {
                    return ''
                }

                if(this.component.border === 'rounded') {
                    return 'rounded-lg'
                }

                return `rounded-${this.component.border}`
            },
            imageStyles() {
                return `${this.sizeStyles} ${this.objectFitStyle}`
            },
            sizeStyles () {
                if(!this.component.width && !this.component.height) {
                    return ''
                }
                if(!this.component.width) {
                    return `height: ${this.component.height}px !important;`
                }
                if(!this.component.height) {
                    return `width: ${this.component.width}px !important;`
                }

                return `width: ${this.component.width}px !important; height: ${this.component.height}px !important;`
            },
            objectFitStyle() {
                if(!this.component.objectFit || this.component.objectFit === 'none') {
                    return ''
                }

                return `object-fit: ${this.component.objectFit};`
            }
        }
    }
</script>

<style>

</style>